export default {
  "核心概念": {
    "title": "Instance",
    "url": "guide/state.html",
    "sub": {
      "State": "guide/state.html",
      "Getter": "guide/getter.html",
      "Mutations": "guide/mutations.html",
      "Action": "guide/action.html",
      "Module": "guide/module.html",
    }
  },
  "构造器选项": {
    "title": "Options",
    "url": "#vuex-store-构造器选项",
    "sub": {
      "state <small>: Object | Function</small>": "#state",
      "mutations <small>: {[type: string]: Function}</small>": "#mutations",
      "actions <small>: {[type: string]: Function}</small>": "#actions",
      "getters <small>: {[key: string]: Function}</small>": "#getters",
      "modules <small>: object</small>": "#modules",
      "plugins <small>: Array<Function></small>": "#plugins",
      "strict <small>: boolean</small>": "#strict",
      "devtools  <small>: boolean</small>": "#devtools"
    }
  },
  "实例属性": {
    "title": "Instance",
    "url": "#vuex-store-构造器选项",
    "sub": {
      "state": "#state-2",
      "getters": "#getters-2"
    }
  },
  "实例方法": {
    "title": "Instance",
    "url": "#vuex-store-构造器选项",
    "sub": {
      "commit": "#commit",
      "dispatch": "#dispatch",
      "replaceState": "#replacestate",
      "watch": "#watch",
      "subscribe": "#subscribe",
      "subscribeAction": "#subscribeaction@2.5",
      "registerModule": "#registermodule",
      "unregisterModule": "#unregistermodule",
      "hasModule": "#hasModule@3.2",
      "hotUpdate": "#hotupdate"
    }
  },
  "辅助函数": {
    "title": "Methods",
    "url": "#组件绑定的辅助函数",
    "sub": {
      "mapState": "#mapstate",
      "mapGetters": "#mapgetters",
      "mapActions": "#mapactions",
      "mapMutations": "#mapmutations",
      "createNamespacedHelpers": "#createnamespacedhelpers",
    }
  }
}
